/**
 * Sorts condition groups by condition_order_group from nested list
 *
 * Takes an array of condition groups where each group has a nested list
 * with items containing condition_order_group property.
 * Returns a new sorted array (does not mutate original).
 *
 * @param {Array} conditionGroups - Array of condition group objects
 * @returns {Array} Sorted copy of condition groups array
 *
 * @example
 * const sorted = sortConditionGroupsByOrder(manufacturer.list)
 */
export function sortConditionGroupsByOrder(conditionGroups) {
    if (!conditionGroups || !Array.isArray(conditionGroups)) {
        return []
    }

    return [...conditionGroups].sort((a, b) => {
        // Get condition_order_group from nested list
        const orderA = a.list?.[0]?.condition_order_group ?? 0
        const orderB = b.list?.[0]?.condition_order_group ?? 0
        return orderA - orderB
    })
}
